import Vue from "vue";
import App from "./App.vue";

import "framework7/css/framework7.bundle.min.css";
import "framework7-icons/css/framework7-icons.css";
import Framework7 from "framework7/framework7.esm.bundle.js";
import Framework7Vue from "framework7-vue/framework7-vue.esm.bundle.js";
Framework7.use(Framework7Vue);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  render: h => h(App)
});
